import { cn } from "@/lib/utils";

/**
 * Home gradient backdrop (panel-level so it bleeds under anything that overlays it). The base
 * gradient stops on the operator-themed `--wx-bg` so the bottom edge dissolves cleanly into the
 * panel below the `h-96` band. The radial glow colour is `--wx-home-glow` (the theme's
 * `homeBackdrop`, else its `primary`, else the bundled indigo) at 22% (light) / 35% (dark), unless the colour carries its own alpha (`--wx-home-glow-a: 100%`); with
 * `glow={false}` (`theme.homeBackdropGlow: false`) only the vertical surface gradient remains.
 */
export function HomeBackdrop({ glow }: { glow: boolean }) {
  return (
    <div
      aria-hidden="true"
      data-wx-home-backdrop={glow ? "glow" : "plain"}
      className={cn(
        "pointer-events-none absolute inset-x-0 top-0 -z-10 h-96",
        glow
          ? "bg-[radial-gradient(120%_80%_at_50%_-10%,color-mix(in_srgb,var(--wx-home-glow)_var(--wx-home-glow-a,22%),transparent),transparent_55%),linear-gradient(to_bottom,var(--wx-bg-elevated-2)_0%,var(--wx-bg-elevated)_40%,var(--wx-bg)_75%)] dark:bg-[radial-gradient(120%_80%_at_50%_-10%,color-mix(in_srgb,var(--wx-home-glow)_var(--wx-home-glow-a,35%),transparent),transparent_55%),linear-gradient(to_bottom,var(--wx-bg-elevated-2)_0%,var(--wx-bg-elevated)_40%,var(--wx-bg)_75%)]"
          : "bg-[linear-gradient(to_bottom,var(--wx-bg-elevated-2)_0%,var(--wx-bg-elevated)_40%,var(--wx-bg)_75%)]",
      )}
    />
  );
}
